exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-post-markdown-remark-frontmatter-slug-js": () => import("./../../../src/pages/post/{markdownRemark.frontmatter__slug}.js" /* webpackChunkName: "component---src-pages-post-markdown-remark-frontmatter-slug-js" */)
}

